import { useContext, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { Chat } from '@trinity/chat';
import { ChatContextType, ChatHintType } from '@trinity/chat';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { useActiveBrandIdentifier } from '@trinity/chat-components/containers/UserBrands/useActiveBrandIdentifier';
import {
  ActiveChatSessionContext,
  ChatHintsContext,
  ChatHintsLoadingContext,
  ChatInitialMessageContext,
} from './context';

type Props = {
  children: React.ReactNode;
};

export const ChatHintsContainer = (props: Props) => {
  const chat = useContext(ActiveChatSessionContext);
  const brandIdentifier = useActiveBrandIdentifier();
  const client = useChatApiClient();

  const query = useQuery({
    queryKey: ['chat-hints', chat.context, brandIdentifier],
    queryFn: () => {
      return client.chat.getChatInitialMessage({
        context: chat.context,
        brandIdentifier,
      });
    },
    initialData: {
      hints: [],
      message: '',
    },
  });

  const loading = useMemo(() => {
    return query.isFetching;
  }, [query.isFetching]);

  return (
    <ChatInitialMessageContext.Provider value={query.data.message}>
      <ChatHintsContext.Provider value={query.data.hints}>
        <ChatHintsLoadingContext.Provider value={loading}>
          {props.children}
        </ChatHintsLoadingContext.Provider>
      </ChatHintsContext.Provider>
    </ChatInitialMessageContext.Provider>
  );
};